import { patientCasesServices } from "../../Services/PatientCasesServices/patientCases.services";


const patientCasesListing = async () => {
    let response = await patientCasesServices.patientCasesList();
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientCasesDetail = async (id) => {
    let response = await patientCasesServices.patientCasesDetails(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientCasesCreate = async () => {
    let post = {
        name: "Honey",
        phonenumber: "989498799",
        uh_id: "#HID88",
        email: null,
        dob: "12-12-1995",
        gender: "male",
        blood_group: null,
        address: "Ludhiana",
        city: "Ludhiana",
        state: "Punjab",
        patient_status: "admitted",
        summary: null,
        insurance: 1,
        relation_type: null,
        relative_name: null,
        relative_phonenumber: null,
        hospital: [1, 2]
    }
    let response = await patientCasesServices.patientCasesCreate(post);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientCasesUpdate = async (id) => {
    let response = await patientCasesServices.patientCasesUpdate(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};


const patientCasesDelete = async (id) => {
    let response = await patientCasesServices.patientCasesDelete(id);
    if (response && response.status) {
        return response;
    } else {
        return null;
    }
};
 

const patientCasesController = {
    patientCasesListing,
    patientCasesDetail,
    patientCasesCreate,
    patientCasesUpdate,
    patientCasesDelete
};

export default patientCasesController;
